module.exports = __webpack_public_path__ + "img/Vector 75.83a9a99b.png";